var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"separator"},[_c('div',{staticClass:"separator__item"},[_vm._v(" ")]),(_vm.debug.visible)?_c('DebugItem',{attrs:{"data":_vm.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }